import { getColumnType } from "../../../column"

export const setGridRowNumbersColumnWidth = grid => {
	const { store } = grid || {}
	const { rowNumbererColumn } = grid.gridItems && grid.gridItems[0] || grid || {}
	if (!rowNumbererColumn || !store) return
	const width = rowNumbererColumn.getWidth()
	const newWidth = `${33 + Math.floor(Math.log10(store.data.length || 1)) * 7}px`
	newWidth !== width && rowNumbererColumn.setWidth(newWidth)
}

/**
 * 解析出column定义:{
 * columnIndex: -1代表双击在空白区域
 * field: 数据项
 * text: 列项标题
 * }
 */
export const getColumnInfo = (grid, location) => {
	const { sourceElement, column: columnSource } = location

	const column = {}
	if (sourceElement.id.includes('gridrow'))
		column.columnIndex = -1
	else {
		column.columnIndex = grid._columns.indexOf(columnSource)
		if (column.columnIndex >= 0) {
			column.field = columnSource.config.dataIndex
			column.text = columnSource.config.text

			const { allPartners = [] } = grid
			for (const partner of allPartners) {
				if (partner === grid) break
				column.columnIndex += partner._columns.length
			}
		}
	}

	// console.log('column:', column, columnSource)
	return column
}

export const preventCtrlR = (e, el) => e.preventDefault()

// 内部
export const innerSearchFn = (searchString, filter, setState) => {
	setState({})
}

export const doInnerSearch = (list, { filter, searchString, oldColumns }) => {
	const filterFns = {
		'like': (v, c) => v && v.includes(c),
		'!like': (v, c) => !v || !v.includes(c),
		'=': (v, c) => v == c,
		'>=': (v, c) => v >= c,
		'<=': (v, c) => v <= c,
		'!=': (v, c) => v != c,
		'in': (v, c) => v && c.includes(v),
		'!in': (v, c) => !v || !c.includes(v),
	}

	const trueFn = () => true

	const genFilterFn = (field, filterItem) => {
		// filterItem 转换为数组，并将日期数据(数组)简化为日期值
		// 20240226 针对 in !in 不去除 数组
		const filter = Object.entries(filterItem).map(([n, c]) => ([n, Array.isArray(c) && !['in', '!in'].includes(n) ? c[0] : c]))
		return data => {
			for (const [item, c] of filter) {
				if (!(filterFns[item] || trueFn)(data[field], c)) return false
			}
			return true
		}
	}

	// 支持使用空格来搜索多个字符串，或关系
	const searchArr = searchString && searchString.split(/\s+/)

	const { columnFields, searchColumns } = oldColumns.reduce((sum, col, index) => {
		const type = getColumnType(col)
		const field = col.field || col[type]

		sum.columnFields[field] = { field, type, ...col }
		if (col.search || col.search || (col.search !== false && col.filter))
			sum.searchColumns.push(sum.columnFields[field])

		return sum
	}, { columnFields: {}, searchColumns: [] })

	const filterEntries = filter ? Object.entries(filter) : []

	const doSearchFilter = () => {
		// searchString
		list = searchString
			? list.filter((d, index) => searchColumns.find(col => d[col.field] && searchArr.find(s => String(d[col.field]).includes(s))))
			: list

		// 逐个过滤 
		list = filterEntries.length
			? filterEntries.reduce((list, [field, filterItem]) => list.filter(genFilterFn(field, filterItem)), list)
			: list

		return list
	}

	const ret = list && (filterEntries.length || searchString ? doSearchFilter() : list)

	return ret
}

export const hasMultiLines = columns => {
	for (const { items, _richtext, edit } of columns) {
		if (items ? hasMultiLines(items) : (_richtext != undefined || edit?.maxRows))
			return true
	}
	return false
}

export const hasEditable = columns => {
	for (const { items, editable } of columns) {
		if (items ? hasEditable(items) : editable)
			return true
	}

	return false
}